var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "setting-main-container" }, [
    _c(
      "form",
      {
        attrs: { action: "" },
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.submitBusinessData($event)
          },
        },
      },
      [
        _c("div", { staticClass: "card setting-card" }, [
          _c("div", { staticClass: "page-header" }, [
            _c("h3", { staticClass: "page-title" }, [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "profile.financial_institutions.financial_institutions"
                  )
                )
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-md-6 mb-4" },
              [
                _c("label", { staticClass: "input-label" }, [
                  _vm._v(
                    _vm._s(_vm.$tc("profile.financial_institutions.imports"))
                  ),
                ]),
                _vm._v(" "),
                _c("base-input", {
                  model: {
                    value: _vm.formData.imports,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "imports", $$v)
                    },
                    expression: "formData.imports",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-6 mb-4" },
              [
                _c("label", { staticClass: "input-label" }, [
                  _vm._v(
                    _vm._s(_vm.$tc("profile.financial_institutions.exports"))
                  ),
                ]),
                _vm._v(" "),
                _c("base-input", {
                  model: {
                    value: _vm.formData.exports,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "exports", $$v)
                    },
                    expression: "formData.exports",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-12 mb-4" },
              [
                _c("label", { staticClass: "input-label" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$tc(
                        "profile.financial_institutions.remittances_effect"
                      )
                    )
                  ),
                ]),
                _vm._v(" "),
                _c("base-text-area", {
                  on: {
                    input: function ($event) {
                      return _vm.$v.formData.remittances_effected.$touch()
                    },
                  },
                  model: {
                    value: _vm.formData.remittances_effected,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "remittances_effected", $$v)
                    },
                    expression: "formData.remittances_effected",
                  },
                }),
                _vm._v(" "),
                _vm.$v.formData.remittances_effected.$error
                  ? _c("div", [
                      !_vm.$v.formData.remittances_effected.maxLength
                        ? _c("span", { staticClass: "text-danger" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$tc(
                                  "validation.remittances_effected_maxlength"
                                )
                              )
                            ),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-md-12" },
              [
                _c(
                  "base-button",
                  {
                    attrs: {
                      loading: _vm.isLoading,
                      disabled: _vm.isLoading,
                      icon: "save",
                      color: "theme",
                      type: "submit",
                    },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$tc("profile.business_status.save")) +
                        "\n          "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }